<template>
  <div class="comment_content">
    <van-action-sheet
      @click-overlay="closeMark"
      v-model="show"
      get-container="#app"
      :closeable="false"
      cancel-text="确定"
      @cancel="submitComment"
    >
      <van-field
        v-model="parmas.content"
        rows="2"
        autosize
        label="评论"
        type="textarea"
        maxlength="100"
        placeholder="请输入评论"
        show-word-limit
      />
    </van-action-sheet>
  </div>
</template>

<script>
// @ is an alias to /src
import { ActionSheet, Field } from "vant";

import { publishCommentApi } from "@/api/info";

export default {
  props: {
    //此处一定要用value
    value: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    itemId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    items: {
      type: Object,
      default: () => {
        return {};
      }
    },
    replies_items: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: () => {
        return "";
      }
    },
    parmasData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  name: "comment_content",
  components: {
    [ActionSheet.name]: ActionSheet,
    [Field.name]: Field
  },
  data() {
    return {
      show: this.value,
      status: false,
      item_id: this.items.id,
      parmas: {
        reply_user_id: 0,
        reply_comment_id: 0,
        content: "",
        top_comment_id: 0
      }
    };
  },

  methods: {
    // 提交评论
    submitComment() {
      if (this.itemId) {
        this.item_id = this.itemId;
      }
      if (this.type === "reply") {
        this.parmas.reply_user_id = this.items.user.id;
        this.parmas.reply_comment_id = this.items.id;
      }
      // 如果是回复评论
      if (Object.keys(this.replies_items).length !== 0) {
        this.parmas.reply_user_id = this.replies_items.user.id;
        this.parmas.reply_comment_id = this.replies_items.id;
        this.parmas.top_comment_id = this.items.id;
        this.item_id = this.replies_items.id;
      }
      // 如果有直接参数穿过来
      if (Object.keys(this.parmasData).length !== 0) {
        this.parmas.reply_user_id = this.parmasData.reply_user_id;
        this.parmas.reply_comment_id = this.parmasData.reply_comment_id;
        this.parmas.top_comment_id = this.parmasData.top_comment_id;
      }
      publishCommentApi(this.item_id, this.parmas)
        .then(res => {
          this.$emit("getCommentTxt", res.data);
        })
        .catch(() => {
          this.$emit("close");
        });
    },

    closeMark() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.content {
  padding: 16px 16px 160px;
}

.comment_content {
  width: 100%;
  height: 100%;
}
</style>
